<template>
  <div>
    <b-card class="bg-white rounded-xl">
      <div class="flex  justify-between  items-center">
        <div>
          <h2 class="text-2xl font-semibold">
            Products
          </h2>

          <small class=" text-muted "
            >Lorem ipsum dolor sit amet, consectetur adipiscing elit,
          </small>
        </div>

        <div>
          <base-button outline type="success" class="flex">
            <feather-icon icon="PlusIcon" class="mr-1"></feather-icon>Add
            Product
          </base-button>
        </div>
      </div>
      <b-input-group class="mt-12">
        <b-form-input
          class="border-none shadow-lg"
          type="text"
          min="0.00"
          placeholder="Enter Search...."
        ></b-form-input>

        <b-input-group-append>
          <b-button
            variant="white"
            class="flex items-center shadow-lg"
            aria-label="search"
          >
            <feather-icon
              class=" cursor-pointer  mr-2"
              icon="SearchIcon"
              svgClasses="w-4 h-4"
            ></feather-icon>
          </b-button>
        </b-input-group-append>
      </b-input-group>
      <div class="mt-8">
        <ProductsCard
          :item="item"
          v-for="(item, index) in products"
          :key="'item -' + index"
        />
      </div>
    </b-card>
  </div>
</template>

<script>
import "../../scss/Index.scss";
import ProductsCard from "./components/ProductsCard";
export default {
  components: {
    ProductsCard
  },
  data() {
    return {
      products: [
        {
          title: "Anouk",
          img: require("./img/p4.webp"),
          description:
            "“Lorem ipsum dolor sit amet, consectetur adipiscing elit."
        },
        {
          title: "Inddus",
          img: require("./img/p5.webp"),
          description:
            "“Lorem ipsum dolor sit amet, consectetur adipiscing elit."
        },
        {
          title: "EthnoVogue",
          img: require("./img/p6.webp"),
          description:
            "“Lorem ipsum dolor sit amet, consectetur adipiscing elit."
        }
      ]
    };
  }
};
</script>
